import { render, staticRenderFns } from "./TransactionItemDetails.vue?vue&type=template&id=1c5a3e4e&scoped=true&"
import script from "./TransactionItemDetails.vue?vue&type=script&lang=ts&"
export * from "./TransactionItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionItemDetails.vue?vue&type=style&index=0&id=1c5a3e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a3e4e",
  null
  
)

export default component.exports